// Constantes de dominio del módulo reservation. El backend ya expone un contrato
// limpio (enum de estado estable, sin nombres ni centinelas de Zoho).

// Estados de una reserva
export const RESERVATION_STATUS = {
  PENDING_MANAGER: "PENDING_MANAGER",
  APPROVED_MANAGER: "APPROVED_MANAGER",
  REJECTED_MANAGER: "REJECTED_MANAGER",
  PENDING_CEO: "PENDING_CEO",
  APPROVED_CEO: "APPROVED_CEO",
  REJECTED_CEO: "REJECTED_CEO",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
};

export const RESERVATION_MODE = { CREATE: "create", EDIT: "edit" };

// Umbral para el aviso de cancelación tardía (penalización) en la UI.
export const LATE_CANCELLATION_THRESHOLD_DAYS = 5;

export const DEFAULT_DEPARTMENT = "Operaciones";
export const DEFAULT_MAX_GUESTS = 7;

// Endpoints de disponibilidad de habitaciones.
export const AVAILABILITY_ENDPOINT = {
  GENERAL: "availability",
  BY_USER: "availability-by-user",
};

// Palabras clave para clasificar un estado por substring (iconos/colores).
export const STATUS_KEYWORD = { APPROVED: "APPROVED", PENDING: "PENDING" };

// Tipos y relaciones de invitado (GuestModal).
export const GUEST_TYPE = { ADULT: "Adulto", CHILD: "Niño" };
export const GUEST_RELATIONSHIP = {
  PARENT: "Padre/Madre",
  SIBLING: "Hermano/a",
  SPOUSE: "Esposo/a",
  CHILD: "Hijo/a",
  OTHER: "Otro",
};

// Meta de presentación por estado
export const STATUS_CHIP_META = {
  [RESERVATION_STATUS.PENDING_CEO]: { labelKey: "pendingReviewCEO", color: "warning" },
  [RESERVATION_STATUS.APPROVED_CEO]: { labelKey: "approvedCEO", color: "success" },
  [RESERVATION_STATUS.REJECTED_CEO]: { labelKey: "rejectedCEO", color: "error" },
  [RESERVATION_STATUS.PENDING_MANAGER]: { labelKey: "pendingReviewManager", color: "warning" },
  [RESERVATION_STATUS.APPROVED_MANAGER]: { labelKey: "approvedManager", color: "success" },
  [RESERVATION_STATUS.REJECTED_MANAGER]: { labelKey: "rejectedManager", color: "error" },
  [RESERVATION_STATUS.REJECTED]: { labelKey: "rejected", color: "error" },
  [RESERVATION_STATUS.CANCELLED]: { labelKey: "cancelled", color: "error" },
};

export const DEFAULT_STATUS_CHIP_META = { labelKey: "pendingReviewManager", color: "warning" };
